import React from 'react';

const Paragraph = (props) => {
   const {text} = props;
   return (
	<div>
	<p style={{color: 'pink', backgroundColor: 'maroon', textAlign: 'center', fontWeight: 'bold', fontSize: '1.2em', textShadow: '2px 2px black'}}>{text}</p>
	</div>);
};

export default Paragraph;